import PropTypes from 'prop-types'
import styled from 'styled-components'

import { COLOR } from 'styles/constants'
import { textStyle } from 'styles/text-style'

interface IA extends ISpan {
  href: string
  className?: string
  children?: React.ReactNode
}

const StyledA = styled.a<ISpan>`
  ${textStyle}
  ${(props) => props.$pointer && 'cursor: pointer;'}
  ${(props) => `color: ${props.$color ? props.$color : COLOR.BLUE_LV5};`}
`

export const A = ({ children, ...style }: IA) => <StyledA {...style}>{children}</StyledA>

A.propTypes = {
  href: PropTypes.string.isRequired,
}
